import { createStyles, withStyles, type WithStyles } from "@material-ui/core";
import React from "react";
import { ConfigurationItem } from "constants/configurations";
import { AppBar, AppBarConteudoDefault, TabContentDefault } from "../../layout";
import { NavigationTabs } from "../../navegacao";
import { SelectedFarmContainer } from "../../shared/crossCuttingComponents";
import type { ConfigurationItemsVisibility } from "../configurations.types";
import { useConfigurationTabs } from "../hooks/useConfigurationTabs";
import { useTabTransition } from "../hooks/useTabTransition";
import ConfigurationTabContent from "./configurationTabContent";

type ConfigurationTabsProps = {
  hasSelectedFarm: boolean;
  itemsVisibility: ConfigurationItemsVisibility;
  onTabChange: (id: ConfigurationItem) => void;
  selectedTab: ConfigurationItem;
} & WithStyles<typeof styles>;

function ConfigurationTabs({
  classes,
  hasSelectedFarm,
  itemsVisibility,
  onTabChange,
  selectedTab,
}: ConfigurationTabsProps) {
  const { tabs } = useConfigurationTabs({ itemsVisibility, selectedTab });
  const {
    handleCancelChangeTab,
    handleConfirmChangeTab,
    handleRequestChangeTab,
    handleToggleIntercept,
    tabTransition,
  } = useTabTransition({ onSelectedTabChange: onTabChange });

  return (
    <>
      <AppBar
        conteudoCustomizadoAppBar={
          <SelectedFarmContainer
            render={(farm, { noFarmSelectedTitle }) => (
              <AppBarConteudoDefault
                tituloAppBar={farm?.NomeReduzido ?? noFarmSelectedTitle}
              />
            )}
          />
        }
      />

      <NavigationTabs
        classNames={{ paper: classes.tabsPaper }}
        tabs={tabs}
        onTabChange={handleRequestChangeTab}
        selectedTab={selectedTab}
      />
      <div className={classes.contentWrapper}>
        <TabContentDefault>
          <ConfigurationTabContent
            hasSelectedFarm={hasSelectedFarm}
            isTabChangeRequested={tabTransition.isTabChangeRequested}
            itemsVisibility={itemsVisibility}
            onCancelChangeTab={handleCancelChangeTab}
            onConfirmChangeTab={handleConfirmChangeTab}
            selectedTab={selectedTab}
            setInterceptOnChangeTab={handleToggleIntercept}
            targetTabChange={tabTransition.targetTabChange}
          />
        </TabContentDefault>
      </div>
    </>
  );
}

const styles = () =>
  createStyles({
    contentWrapper: {
      width: "100%",
    },
    tabsPaper: {
      backgroundColor: "#f8f8f8",
      minHeight: 60,
      display: "flex",
      alignItems: "center",
      boxShadow: "unset",
    },
  });

export default withStyles(styles)(ConfigurationTabs);
